import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { NewCustomerServiceNoteDialogComponent } from './new-customer-service-note-dialog.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [CommonModule, FormsModule, MatButtonModule, MatInputModule, MatDialogModule],
  exports: [NewCustomerServiceNoteDialogComponent],
  declarations: [NewCustomerServiceNoteDialogComponent]
})
export class NewCustomerServiceNoteDialogModule {}
